














import { Vue, Component, Prop } from 'vue-property-decorator';
import InfoTooltip from '@/components/common/InfoTooltip.vue';

@Component({
  components: {
    InfoTooltip
  }
})
export default class WellItem extends Vue {
  @Prop(String)
  label!: string;
  @Prop(String)
  tooltip!: string;
  @Prop({ default: '50%', type: String })
  labelWidth!: string;
  @Prop(Boolean)
  required!: boolean;
  @Prop(Boolean)
  greyBackground!: boolean;
}
